module.exports = __webpack_public_path__ + "static/ínteseradiante-4b44a18e0c12c650ab361a26d6bb6b11.mp4";